import { Component } from "react";
import FieldModal from "../../../../components/modals/fieldModal";
import API from "../../../../utils/API";

class ClearQueueModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
        }
    }

    clearQueue = async () => {
        const { toggle, checkInAppConfiguration, printer, orgId, eventId } = this.props;
        
        this.setState({ submitting: true });

        try {
            const response = await API().post(
                `Organizations/${orgId}/events/${eventId}/printerDevices/${printer._id}/clearQueue`
            );

            if (response.data) {
                let updatedActivePrinterDevices = checkInAppConfiguration.printerDevices || [];
                const existingIndex = updatedActivePrinterDevices.findIndex(device => device._id === printer._id);
                
                if (existingIndex !== -1) {
                    // Update the printQueueCount to 0 for the cleared printer
                    updatedActivePrinterDevices[existingIndex] = {
                        ...updatedActivePrinterDevices[existingIndex],
                        printQueueCount: 0
                    };
                }
                
                this.props.updatedActivePrinterDevices(updatedActivePrinterDevices);
                toggle();
            }
        } catch (error) {
            console.error('Failed to clear printer queue:', error);
        } finally {
            this.setState({ submitting: false });
        }
    }

    render() {
        const { isOpen, toggle, printer } = this.props;
        const { submitting } = this.state;
        const queueCount = printer ? printer.printQueueCount || 0 : 0;

        return <div>
            <FieldModal
                size="small"
                isOpen={isOpen}
                modalTitle={"Clear Print Queue"}
                bodyHeaderText={''}
                bodyDescription={''}
                bodyContent={() => {
                    return (
                        <div>
                            <p>Are you sure you want to clear the print queue for <strong>{printer ? printer.friendlyName : ''}</strong>?</p>
                            {queueCount > 0 ? (
                                <p className="mt-10 text-muted">This will remove <strong>{queueCount}</strong> job{queueCount !== 1 ? 's' : ''} (including all statuses: pending, failed, completed) from the queue.</p>
                            ) : (
                                <p className="mt-10 text-muted">The print queue is already empty.</p>
                            )}
                        </div>)
                }}
                toggle={toggle}
                actionButtonLabel={!submitting ? 'Clear Queue' : 'Clearing...'}
                actionButton={() => this.clearQueue()}
                actionButtonDisabled={submitting}
                isDelete={true}
            ></FieldModal>
        </div>
    }
}

export default ClearQueueModal;